module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "help-page"
  }, [(_vm.page) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.page.title))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body help-text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linkify(_vm.page.text))
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0d8e2cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpPage.vue
// module id = 2088
// module chunks = 2